<div class="container">
  <p>&nbsp;</p>
	<div class="col-md-12">
		<div class="col-md-6 col-md-offset-4">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="text-center">
                  <h3><i class="fa fa-lock fa-4x"></i></h3>
                  <h2 class="text-center">Forgot Password?</h2>
                  <p>You can reset your password here.</p>
                  <div class="panel-body">
       
                      <div class="form-group">

                          <input v-model="email" name="email" placeholder="email address" class="form-control"  type="email">

                      </div>
                      <div class="form-group">
                        <input name="recover-submit" class="btn btn-lg btn-primary btn-block" value="Reset Password" @click="sendPasswordReset">
                      </div>                   
                      <p>&nbsp;</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
	</div>
</div>
